






























import { Component, Vue } from 'vue-property-decorator'
import Dashboard from './Dashboard.vue'
import AccessToken from '../access-token'

@Component
export default class VueComponent extends Vue {
    $parent!: Dashboard
    get baseUrl() {
        return this.$parent.baseUrl
    }
    get account() {
        return this.$parent.account
    }
    get tokens() {
        return this.$parent.tokens
    }
    get selectedToken(): AccessToken | undefined {
        return this.$parent.selectedToken
    }
    set selectedToken(v: AccessToken | undefined) {
        this.$parent.selectedToken = v
    }
    get selectedTokenName() {
        return this.selectedToken ? this.selectedToken.name : '帶入金鑰...'
    }
    get selectedTokenValue() {
        return this.selectedToken ? this.selectedToken.token : '<金鑰值>'
    }
}
